import { Curriculum } from "../../types/curriculum";
import { CurriculumServiceInterface } from "./CurriculumServiceInterface";
export class CurriculumServiceLocal extends CurriculumServiceInterface {
    curriculums = new Map();
    async getCurriculums() {
        return Array.from(this.curriculums.values()).sort((a, b) => a.title.localeCompare(b.title));
    }
    async getCurriculum(curriculumId) {
        const curriculum = this.curriculums.get(curriculumId);
        if (!curriculum) {
            throw new Error(`Curriculum with id ${curriculumId} not found`);
        }
        return curriculum;
    }
    async createCurriculum(curriculumData) {
        const newCurriculum = new Curriculum(curriculumData);
        this.curriculums.set(newCurriculum.id, newCurriculum);
        return newCurriculum;
    }
    async updateCurriculum(curriculumId, curriculumData) {
        const curriculum = await this.getCurriculum(curriculumId);
        curriculum.update(curriculumData);
        this.curriculums.set(curriculumId, curriculum);
        return curriculum;
    }
}
